export const CONNECT_TITLE = "Connect with Us.!";
export const ENCODED_WHATSAPP_TEXT =
  "Hello%2C%0D%0AI+am+interested+to+know+more+about+the+services+you+provide.";
